import { createSlice } from "@reduxjs/toolkit";

const initialState = {};

const teamMembersSlice = createSlice({
  name: "teamMembers",
  initialState,
  reducers: {},
});
// eslint-disable-next-line
export const {} = teamMembersSlice.actions;
export default teamMembersSlice.reducer;
